var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"loading",class:_vm.loading ? 'active' : ''},[_c('i',{staticClass:"fa fa-spinner fa-spin",staticStyle:{"font-size":"48px","opacity":"0.75"}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }